/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type {
  AnalysisResponse,
  ConvertResultDetailResponse,
  ConvertResultExpenditureOptionsResponse,
  ErrorResponse,
  ExpenditurePredictionAccuracyResponse,
  GetConvertResultExpenditureAnalysisParams,
  GetConvertResultExpenditureOptionsParams,
  GetConvertResultExpendituresParams,
  GetConvertResultRevenueAnalysisParams,
  GetConvertResultRevenueAppropriationAnalysisParams,
  GetConvertResultRevenueAxisRevenueAppropriationsParams,
  GetConvertResultRevenuesParams,
  GetConvertResultsParams,
  PagedConvertResultsResponse,
  PagedExpenditureRecordsResponse,
  PagedRevenueAxisRevenueAppropriationsResponse,
  PagedRevenueRecordsResponse,
  RevenuePredictionAccuracyResponse,
  SettlementStatisticsConvertRequest,
  SettlementStatisticsConvertResponse,
  SettlementStatisticsExpenditureNatureListResponse,
  SettlementStatisticsExpenditureNaturePatchRequest,
  SettlementStatisticsExpenditureNaturePostRequest,
  SettlementStatisticsExpenditurePatchRequest,
  SettlementStatisticsExpenditurePurposeListResponse,
  SettlementStatisticsExpenditurePurposePatchRequest,
  SettlementStatisticsExpenditurePurposePostRequest,
  SettlementStatisticsRevenueAppropriationPatchRequest,
  SettlementStatisticsRevenueAppropriationPostRequest,
  SettlementStatisticsRevenueAppropriationResponse,
  SettlementStatisticsRevenuePatchRequest,
  SettlementStatisticsRevenuePurposeListResponse,
  SettlementStatisticsRevenuePurposePatchRequest,
  SettlementStatisticsRevenuePurposePostRequest,
  SuccessResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 決算統計コンバーター変換結果一覧取得

フィルタリング、検索、ページネーションに対応

 * @summary 決算統計コンバーター変換結果一覧取得
 */
export const getConvertResults = (
  params?: GetConvertResultsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PagedConvertResultsResponse>(
    { url: `/settlement-statistics/convert-results`, method: 'GET', params, signal },
    options,
  );
};

export const getGetConvertResultsQueryKey = (params?: GetConvertResultsParams) => {
  return [`/settlement-statistics/convert-results`, ...(params ? [params] : [])] as const;
};

export const getGetConvertResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResults>>,
  TError = ErrorType<void>,
>(
  params?: GetConvertResultsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResults>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConvertResultsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConvertResults>>> = ({ signal }) =>
    getConvertResults(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResults>>
>;
export type GetConvertResultsQueryError = ErrorType<void>;

export function useGetConvertResults<
  TData = Awaited<ReturnType<typeof getConvertResults>>,
  TError = ErrorType<void>,
>(
  params: undefined | GetConvertResultsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResults>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResults>>,
          TError,
          Awaited<ReturnType<typeof getConvertResults>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResults<
  TData = Awaited<ReturnType<typeof getConvertResults>>,
  TError = ErrorType<void>,
>(
  params?: GetConvertResultsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResults>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResults>>,
          TError,
          Awaited<ReturnType<typeof getConvertResults>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResults<
  TData = Awaited<ReturnType<typeof getConvertResults>>,
  TError = ErrorType<void>,
>(
  params?: GetConvertResultsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResults>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果一覧取得
 */

export function useGetConvertResults<
  TData = Awaited<ReturnType<typeof getConvertResults>>,
  TError = ErrorType<void>,
>(
  params?: GetConvertResultsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResults>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果詳細取得

 * @summary 決算統計コンバーター変換結果詳細取得
 */
export const getConvertResult = (
  convertResultId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ConvertResultDetailResponse>(
    { url: `/settlement-statistics/convert-results/${convertResultId}`, method: 'GET', signal },
    options,
  );
};

export const getGetConvertResultQueryKey = (convertResultId?: string) => {
  return [`/settlement-statistics/convert-results/${convertResultId}`] as const;
};

export const getGetConvertResultQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResult>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResult>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConvertResultQueryKey(convertResultId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConvertResult>>> = ({ signal }) =>
    getConvertResult(convertResultId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResult>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultQueryResult = NonNullable<Awaited<ReturnType<typeof getConvertResult>>>;
export type GetConvertResultQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResult<
  TData = Awaited<ReturnType<typeof getConvertResult>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResult>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResult>>,
          TError,
          Awaited<ReturnType<typeof getConvertResult>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResult<
  TData = Awaited<ReturnType<typeof getConvertResult>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResult>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResult>>,
          TError,
          Awaited<ReturnType<typeof getConvertResult>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResult<
  TData = Awaited<ReturnType<typeof getConvertResult>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResult>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果詳細取得
 */

export function useGetConvertResult<
  TData = Awaited<ReturnType<typeof getConvertResult>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConvertResult>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultQueryOptions(convertResultId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果削除

 * @summary 決算統計コンバーター変換結果削除
 */
export const deleteConvertResult = (
  convertResultId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    { url: `/settlement-statistics/convert-results/${convertResultId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteConvertResultMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConvertResult>>,
    TError,
    { convertResultId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConvertResult>>,
  TError,
  { convertResultId: string },
  TContext
> => {
  const mutationKey = ['deleteConvertResult'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConvertResult>>,
    { convertResultId: string }
  > = (props) => {
    const { convertResultId } = props ?? {};

    return deleteConvertResult(convertResultId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConvertResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConvertResult>>
>;

export type DeleteConvertResultMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果削除
 */
export const useDeleteConvertResult = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteConvertResult>>,
      TError,
      { convertResultId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteConvertResult>>,
  TError,
  { convertResultId: string },
  TContext
> => {
  const mutationOptions = getDeleteConvertResultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換API

 * @summary 決算統計コンバーター変換
 */
export const settlementStatisticsConvert = (
  settlementStatisticsConvertRequest: BodyType<SettlementStatisticsConvertRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SettlementStatisticsConvertResponse>(
    {
      url: `/settlement-statistics/convert`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsConvertRequest,
      signal,
    },
    options,
  );
};

export const getSettlementStatisticsConvertMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof settlementStatisticsConvert>>,
    TError,
    { data: BodyType<SettlementStatisticsConvertRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof settlementStatisticsConvert>>,
  TError,
  { data: BodyType<SettlementStatisticsConvertRequest> },
  TContext
> => {
  const mutationKey = ['settlementStatisticsConvert'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof settlementStatisticsConvert>>,
    { data: BodyType<SettlementStatisticsConvertRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return settlementStatisticsConvert(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SettlementStatisticsConvertMutationResult = NonNullable<
  Awaited<ReturnType<typeof settlementStatisticsConvert>>
>;
export type SettlementStatisticsConvertMutationBody = BodyType<SettlementStatisticsConvertRequest>;
export type SettlementStatisticsConvertMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換
 */
export const useSettlementStatisticsConvert = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof settlementStatisticsConvert>>,
      TError,
      { data: BodyType<SettlementStatisticsConvertRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof settlementStatisticsConvert>>,
  TError,
  { data: BodyType<SettlementStatisticsConvertRequest> },
  TContext
> => {
  const mutationOptions = getSettlementStatisticsConvertMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果で利用する検索条件の選択肢を取得します。
fieldsパラメータで指定した項目のみ返却されます。

 * @summary 決算統計コンバーター変換結果オプション取得
 */
export const getConvertResultExpenditureOptions = (
  convertResultId: string,
  params: GetConvertResultExpenditureOptionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ConvertResultExpenditureOptionsResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/options`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetConvertResultExpenditureOptionsQueryKey = (
  convertResultId?: string,
  params?: GetConvertResultExpenditureOptionsParams,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/options`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConvertResultExpenditureOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: GetConvertResultExpenditureOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultExpenditureOptionsQueryKey(convertResultId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>> = ({
    signal,
  }) => getConvertResultExpenditureOptions(convertResultId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultExpenditureOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>
>;
export type GetConvertResultExpenditureOptionsQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultExpenditureOptions<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: GetConvertResultExpenditureOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditureOptions<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: GetConvertResultExpenditureOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditureOptions<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: GetConvertResultExpenditureOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果オプション取得
 */

export function useGetConvertResultExpenditureOptions<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: GetConvertResultExpenditureOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditureOptions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultExpenditureOptionsQueryOptions(
    convertResultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の決算統計歳出目的の一覧を取得します。

 * @summary 決算統計コンバーター変換結果歳出目的一覧取得
 */
export const getConvertResultSettlementStatisticsExpenditurePurposes = (
  convertResultId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SettlementStatisticsExpenditurePurposeListResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-purposes`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetConvertResultSettlementStatisticsExpenditurePurposesQueryKey = (
  convertResultId?: string,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-purposes`,
  ] as const;
};

export const getGetConvertResultSettlementStatisticsExpenditurePurposesQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultSettlementStatisticsExpenditurePurposesQueryKey(convertResultId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>
  > = ({ signal }) =>
    getConvertResultSettlementStatisticsExpenditurePurposes(
      convertResultId,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultSettlementStatisticsExpenditurePurposesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>
>;
export type GetConvertResultSettlementStatisticsExpenditurePurposesQueryError =
  ErrorType<ErrorResponse>;

export function useGetConvertResultSettlementStatisticsExpenditurePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultSettlementStatisticsExpenditurePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultSettlementStatisticsExpenditurePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳出目的一覧取得
 */

export function useGetConvertResultSettlementStatisticsExpenditurePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditurePurposes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultSettlementStatisticsExpenditurePurposesQueryOptions(
    convertResultId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の決算統計歳出目的を作成します。

 * @summary 決算統計コンバーター変換結果歳出目的作成
 */
export const postSettlementStatisticsExpenditurePurpose = (
  convertResultId: string,
  settlementStatisticsExpenditurePurposePostRequest: BodyType<SettlementStatisticsExpenditurePurposePostRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-purposes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsExpenditurePurposePostRequest,
      signal,
    },
    options,
  );
};

export const getPostSettlementStatisticsExpenditurePurposeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettlementStatisticsExpenditurePurpose>>,
    TError,
    { convertResultId: string; data: BodyType<SettlementStatisticsExpenditurePurposePostRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettlementStatisticsExpenditurePurpose>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsExpenditurePurposePostRequest> },
  TContext
> => {
  const mutationKey = ['postSettlementStatisticsExpenditurePurpose'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettlementStatisticsExpenditurePurpose>>,
    { convertResultId: string; data: BodyType<SettlementStatisticsExpenditurePurposePostRequest> }
  > = (props) => {
    const { convertResultId, data } = props ?? {};

    return postSettlementStatisticsExpenditurePurpose(convertResultId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettlementStatisticsExpenditurePurposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettlementStatisticsExpenditurePurpose>>
>;
export type PostSettlementStatisticsExpenditurePurposeMutationBody =
  BodyType<SettlementStatisticsExpenditurePurposePostRequest>;
export type PostSettlementStatisticsExpenditurePurposeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳出目的作成
 */
export const usePostSettlementStatisticsExpenditurePurpose = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettlementStatisticsExpenditurePurpose>>,
      TError,
      {
        convertResultId: string;
        data: BodyType<SettlementStatisticsExpenditurePurposePostRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettlementStatisticsExpenditurePurpose>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsExpenditurePurposePostRequest> },
  TContext
> => {
  const mutationOptions = getPostSettlementStatisticsExpenditurePurposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳出目的を更新します。

 * @summary 決算統計コンバーター変換結果歳出目的更新
 */
export const patchSettlementStatisticsExpenditurePurpose = (
  convertResultId: string,
  settlementStatisticsExpenditurePurposeId: string,
  settlementStatisticsExpenditurePurposePatchRequest: BodyType<SettlementStatisticsExpenditurePurposePatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-purposes/${settlementStatisticsExpenditurePurposeId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsExpenditurePurposePatchRequest,
    },
    options,
  );
};

export const getPatchSettlementStatisticsExpenditurePurposeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettlementStatisticsExpenditurePurpose>>,
    TError,
    {
      convertResultId: string;
      settlementStatisticsExpenditurePurposeId: string;
      data: BodyType<SettlementStatisticsExpenditurePurposePatchRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditurePurpose>>,
  TError,
  {
    convertResultId: string;
    settlementStatisticsExpenditurePurposeId: string;
    data: BodyType<SettlementStatisticsExpenditurePurposePatchRequest>;
  },
  TContext
> => {
  const mutationKey = ['patchSettlementStatisticsExpenditurePurpose'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettlementStatisticsExpenditurePurpose>>,
    {
      convertResultId: string;
      settlementStatisticsExpenditurePurposeId: string;
      data: BodyType<SettlementStatisticsExpenditurePurposePatchRequest>;
    }
  > = (props) => {
    const { convertResultId, settlementStatisticsExpenditurePurposeId, data } = props ?? {};

    return patchSettlementStatisticsExpenditurePurpose(
      convertResultId,
      settlementStatisticsExpenditurePurposeId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettlementStatisticsExpenditurePurposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditurePurpose>>
>;
export type PatchSettlementStatisticsExpenditurePurposeMutationBody =
  BodyType<SettlementStatisticsExpenditurePurposePatchRequest>;
export type PatchSettlementStatisticsExpenditurePurposeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳出目的更新
 */
export const usePatchSettlementStatisticsExpenditurePurpose = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettlementStatisticsExpenditurePurpose>>,
      TError,
      {
        convertResultId: string;
        settlementStatisticsExpenditurePurposeId: string;
        data: BodyType<SettlementStatisticsExpenditurePurposePatchRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditurePurpose>>,
  TError,
  {
    convertResultId: string;
    settlementStatisticsExpenditurePurposeId: string;
    data: BodyType<SettlementStatisticsExpenditurePurposePatchRequest>;
  },
  TContext
> => {
  const mutationOptions = getPatchSettlementStatisticsExpenditurePurposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳出目的を削除します。

 * @summary 決算統計コンバーター変換結果歳出目的削除
 */
export const deleteSettlementStatisticsExpenditurePurpose = (
  convertResultId: string,
  settlementStatisticsExpenditurePurposeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-purposes/${settlementStatisticsExpenditurePurposeId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteSettlementStatisticsExpenditurePurposeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditurePurpose>>,
    TError,
    { convertResultId: string; settlementStatisticsExpenditurePurposeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditurePurpose>>,
  TError,
  { convertResultId: string; settlementStatisticsExpenditurePurposeId: string },
  TContext
> => {
  const mutationKey = ['deleteSettlementStatisticsExpenditurePurpose'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditurePurpose>>,
    { convertResultId: string; settlementStatisticsExpenditurePurposeId: string }
  > = (props) => {
    const { convertResultId, settlementStatisticsExpenditurePurposeId } = props ?? {};

    return deleteSettlementStatisticsExpenditurePurpose(
      convertResultId,
      settlementStatisticsExpenditurePurposeId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSettlementStatisticsExpenditurePurposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditurePurpose>>
>;

export type DeleteSettlementStatisticsExpenditurePurposeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳出目的削除
 */
export const useDeleteSettlementStatisticsExpenditurePurpose = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditurePurpose>>,
      TError,
      { convertResultId: string; settlementStatisticsExpenditurePurposeId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditurePurpose>>,
  TError,
  { convertResultId: string; settlementStatisticsExpenditurePurposeId: string },
  TContext
> => {
  const mutationOptions = getDeleteSettlementStatisticsExpenditurePurposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳出性質の一覧を取得します。

 * @summary 決算統計コンバーター変換結果歳出性質一覧取得
 */
export const getConvertResultSettlementStatisticsExpenditureNatures = (
  convertResultId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SettlementStatisticsExpenditureNatureListResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-natures`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetConvertResultSettlementStatisticsExpenditureNaturesQueryKey = (
  convertResultId?: string,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-natures`,
  ] as const;
};

export const getGetConvertResultSettlementStatisticsExpenditureNaturesQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultSettlementStatisticsExpenditureNaturesQueryKey(convertResultId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>
  > = ({ signal }) =>
    getConvertResultSettlementStatisticsExpenditureNatures(convertResultId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultSettlementStatisticsExpenditureNaturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>
>;
export type GetConvertResultSettlementStatisticsExpenditureNaturesQueryError =
  ErrorType<ErrorResponse>;

export function useGetConvertResultSettlementStatisticsExpenditureNatures<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultSettlementStatisticsExpenditureNatures<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultSettlementStatisticsExpenditureNatures<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳出性質一覧取得
 */

export function useGetConvertResultSettlementStatisticsExpenditureNatures<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsExpenditureNatures>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultSettlementStatisticsExpenditureNaturesQueryOptions(
    convertResultId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の決算統計歳出性質を作成します。

 * @summary 決算統計コンバーター変換結果歳出性質作成
 */
export const postSettlementStatisticsExpenditureNature = (
  convertResultId: string,
  settlementStatisticsExpenditureNaturePostRequest: BodyType<SettlementStatisticsExpenditureNaturePostRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-natures`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsExpenditureNaturePostRequest,
      signal,
    },
    options,
  );
};

export const getPostSettlementStatisticsExpenditureNatureMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettlementStatisticsExpenditureNature>>,
    TError,
    { convertResultId: string; data: BodyType<SettlementStatisticsExpenditureNaturePostRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettlementStatisticsExpenditureNature>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsExpenditureNaturePostRequest> },
  TContext
> => {
  const mutationKey = ['postSettlementStatisticsExpenditureNature'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettlementStatisticsExpenditureNature>>,
    { convertResultId: string; data: BodyType<SettlementStatisticsExpenditureNaturePostRequest> }
  > = (props) => {
    const { convertResultId, data } = props ?? {};

    return postSettlementStatisticsExpenditureNature(convertResultId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettlementStatisticsExpenditureNatureMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettlementStatisticsExpenditureNature>>
>;
export type PostSettlementStatisticsExpenditureNatureMutationBody =
  BodyType<SettlementStatisticsExpenditureNaturePostRequest>;
export type PostSettlementStatisticsExpenditureNatureMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳出性質作成
 */
export const usePostSettlementStatisticsExpenditureNature = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettlementStatisticsExpenditureNature>>,
      TError,
      { convertResultId: string; data: BodyType<SettlementStatisticsExpenditureNaturePostRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettlementStatisticsExpenditureNature>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsExpenditureNaturePostRequest> },
  TContext
> => {
  const mutationOptions = getPostSettlementStatisticsExpenditureNatureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳出性質を更新します。

 * @summary 決算統計コンバーター変換結果歳出性質更新
 */
export const patchSettlementStatisticsExpenditureNature = (
  convertResultId: string,
  settlementStatisticsExpenditureNatureId: string,
  settlementStatisticsExpenditureNaturePatchRequest: BodyType<SettlementStatisticsExpenditureNaturePatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-natures/${settlementStatisticsExpenditureNatureId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsExpenditureNaturePatchRequest,
    },
    options,
  );
};

export const getPatchSettlementStatisticsExpenditureNatureMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettlementStatisticsExpenditureNature>>,
    TError,
    {
      convertResultId: string;
      settlementStatisticsExpenditureNatureId: string;
      data: BodyType<SettlementStatisticsExpenditureNaturePatchRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditureNature>>,
  TError,
  {
    convertResultId: string;
    settlementStatisticsExpenditureNatureId: string;
    data: BodyType<SettlementStatisticsExpenditureNaturePatchRequest>;
  },
  TContext
> => {
  const mutationKey = ['patchSettlementStatisticsExpenditureNature'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettlementStatisticsExpenditureNature>>,
    {
      convertResultId: string;
      settlementStatisticsExpenditureNatureId: string;
      data: BodyType<SettlementStatisticsExpenditureNaturePatchRequest>;
    }
  > = (props) => {
    const { convertResultId, settlementStatisticsExpenditureNatureId, data } = props ?? {};

    return patchSettlementStatisticsExpenditureNature(
      convertResultId,
      settlementStatisticsExpenditureNatureId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettlementStatisticsExpenditureNatureMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditureNature>>
>;
export type PatchSettlementStatisticsExpenditureNatureMutationBody =
  BodyType<SettlementStatisticsExpenditureNaturePatchRequest>;
export type PatchSettlementStatisticsExpenditureNatureMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳出性質更新
 */
export const usePatchSettlementStatisticsExpenditureNature = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettlementStatisticsExpenditureNature>>,
      TError,
      {
        convertResultId: string;
        settlementStatisticsExpenditureNatureId: string;
        data: BodyType<SettlementStatisticsExpenditureNaturePatchRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditureNature>>,
  TError,
  {
    convertResultId: string;
    settlementStatisticsExpenditureNatureId: string;
    data: BodyType<SettlementStatisticsExpenditureNaturePatchRequest>;
  },
  TContext
> => {
  const mutationOptions = getPatchSettlementStatisticsExpenditureNatureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳出性質を削除します。

 * @summary 決算統計コンバーター変換結果歳出性質削除
 */
export const deleteSettlementStatisticsExpenditureNature = (
  convertResultId: string,
  settlementStatisticsExpenditureNatureId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-expenditure-natures/${settlementStatisticsExpenditureNatureId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteSettlementStatisticsExpenditureNatureMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditureNature>>,
    TError,
    { convertResultId: string; settlementStatisticsExpenditureNatureId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditureNature>>,
  TError,
  { convertResultId: string; settlementStatisticsExpenditureNatureId: string },
  TContext
> => {
  const mutationKey = ['deleteSettlementStatisticsExpenditureNature'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditureNature>>,
    { convertResultId: string; settlementStatisticsExpenditureNatureId: string }
  > = (props) => {
    const { convertResultId, settlementStatisticsExpenditureNatureId } = props ?? {};

    return deleteSettlementStatisticsExpenditureNature(
      convertResultId,
      settlementStatisticsExpenditureNatureId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSettlementStatisticsExpenditureNatureMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditureNature>>
>;

export type DeleteSettlementStatisticsExpenditureNatureMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳出性質削除
 */
export const useDeleteSettlementStatisticsExpenditureNature = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditureNature>>,
      TError,
      { convertResultId: string; settlementStatisticsExpenditureNatureId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSettlementStatisticsExpenditureNature>>,
  TError,
  { convertResultId: string; settlementStatisticsExpenditureNatureId: string },
  TContext
> => {
  const mutationOptions = getDeleteSettlementStatisticsExpenditureNatureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳入区分の一覧を取得します。

 * @summary 決算統計コンバーター変換結果歳入区分一覧取得
 */
export const getConvertResultSettlementStatisticsRevenuePurposes = (
  convertResultId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SettlementStatisticsRevenuePurposeListResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-revenue-purposes`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetConvertResultSettlementStatisticsRevenuePurposesQueryKey = (
  convertResultId?: string,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-revenue-purposes`,
  ] as const;
};

export const getGetConvertResultSettlementStatisticsRevenuePurposesQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultSettlementStatisticsRevenuePurposesQueryKey(convertResultId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>
  > = ({ signal }) =>
    getConvertResultSettlementStatisticsRevenuePurposes(convertResultId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultSettlementStatisticsRevenuePurposesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>
>;
export type GetConvertResultSettlementStatisticsRevenuePurposesQueryError =
  ErrorType<ErrorResponse>;

export function useGetConvertResultSettlementStatisticsRevenuePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultSettlementStatisticsRevenuePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultSettlementStatisticsRevenuePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳入区分一覧取得
 */

export function useGetConvertResultSettlementStatisticsRevenuePurposes<
  TData = Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultSettlementStatisticsRevenuePurposes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultSettlementStatisticsRevenuePurposesQueryOptions(
    convertResultId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の決算統計歳入区分を作成します。

 * @summary 決算統計コンバーター変換結果歳入区分作成
 */
export const postSettlementStatisticsRevenuePurpose = (
  convertResultId: string,
  settlementStatisticsRevenuePurposePostRequest: BodyType<SettlementStatisticsRevenuePurposePostRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-revenue-purposes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsRevenuePurposePostRequest,
      signal,
    },
    options,
  );
};

export const getPostSettlementStatisticsRevenuePurposeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettlementStatisticsRevenuePurpose>>,
    TError,
    { convertResultId: string; data: BodyType<SettlementStatisticsRevenuePurposePostRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettlementStatisticsRevenuePurpose>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsRevenuePurposePostRequest> },
  TContext
> => {
  const mutationKey = ['postSettlementStatisticsRevenuePurpose'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettlementStatisticsRevenuePurpose>>,
    { convertResultId: string; data: BodyType<SettlementStatisticsRevenuePurposePostRequest> }
  > = (props) => {
    const { convertResultId, data } = props ?? {};

    return postSettlementStatisticsRevenuePurpose(convertResultId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettlementStatisticsRevenuePurposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettlementStatisticsRevenuePurpose>>
>;
export type PostSettlementStatisticsRevenuePurposeMutationBody =
  BodyType<SettlementStatisticsRevenuePurposePostRequest>;
export type PostSettlementStatisticsRevenuePurposeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳入区分作成
 */
export const usePostSettlementStatisticsRevenuePurpose = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettlementStatisticsRevenuePurpose>>,
      TError,
      { convertResultId: string; data: BodyType<SettlementStatisticsRevenuePurposePostRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettlementStatisticsRevenuePurpose>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsRevenuePurposePostRequest> },
  TContext
> => {
  const mutationOptions = getPostSettlementStatisticsRevenuePurposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳入区分を更新します。

 * @summary 決算統計コンバーター変換結果歳入区分更新
 */
export const patchSettlementStatisticsRevenuePurpose = (
  convertResultId: string,
  settlementStatisticsRevenuePurposeId: string,
  settlementStatisticsRevenuePurposePatchRequest: BodyType<SettlementStatisticsRevenuePurposePatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-revenue-purposes/${settlementStatisticsRevenuePurposeId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsRevenuePurposePatchRequest,
    },
    options,
  );
};

export const getPatchSettlementStatisticsRevenuePurposeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettlementStatisticsRevenuePurpose>>,
    TError,
    {
      convertResultId: string;
      settlementStatisticsRevenuePurposeId: string;
      data: BodyType<SettlementStatisticsRevenuePurposePatchRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenuePurpose>>,
  TError,
  {
    convertResultId: string;
    settlementStatisticsRevenuePurposeId: string;
    data: BodyType<SettlementStatisticsRevenuePurposePatchRequest>;
  },
  TContext
> => {
  const mutationKey = ['patchSettlementStatisticsRevenuePurpose'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettlementStatisticsRevenuePurpose>>,
    {
      convertResultId: string;
      settlementStatisticsRevenuePurposeId: string;
      data: BodyType<SettlementStatisticsRevenuePurposePatchRequest>;
    }
  > = (props) => {
    const { convertResultId, settlementStatisticsRevenuePurposeId, data } = props ?? {};

    return patchSettlementStatisticsRevenuePurpose(
      convertResultId,
      settlementStatisticsRevenuePurposeId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettlementStatisticsRevenuePurposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenuePurpose>>
>;
export type PatchSettlementStatisticsRevenuePurposeMutationBody =
  BodyType<SettlementStatisticsRevenuePurposePatchRequest>;
export type PatchSettlementStatisticsRevenuePurposeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳入区分更新
 */
export const usePatchSettlementStatisticsRevenuePurpose = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettlementStatisticsRevenuePurpose>>,
      TError,
      {
        convertResultId: string;
        settlementStatisticsRevenuePurposeId: string;
        data: BodyType<SettlementStatisticsRevenuePurposePatchRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenuePurpose>>,
  TError,
  {
    convertResultId: string;
    settlementStatisticsRevenuePurposeId: string;
    data: BodyType<SettlementStatisticsRevenuePurposePatchRequest>;
  },
  TContext
> => {
  const mutationOptions = getPatchSettlementStatisticsRevenuePurposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の決算統計歳入区分を削除します。

 * @summary 決算統計コンバーター変換結果歳入区分削除
 */
export const deleteSettlementStatisticsRevenuePurpose = (
  convertResultId: string,
  settlementStatisticsRevenuePurposeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/settlement-statistics-revenue-purposes/${settlementStatisticsRevenuePurposeId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteSettlementStatisticsRevenuePurposeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSettlementStatisticsRevenuePurpose>>,
    TError,
    { convertResultId: string; settlementStatisticsRevenuePurposeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSettlementStatisticsRevenuePurpose>>,
  TError,
  { convertResultId: string; settlementStatisticsRevenuePurposeId: string },
  TContext
> => {
  const mutationKey = ['deleteSettlementStatisticsRevenuePurpose'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSettlementStatisticsRevenuePurpose>>,
    { convertResultId: string; settlementStatisticsRevenuePurposeId: string }
  > = (props) => {
    const { convertResultId, settlementStatisticsRevenuePurposeId } = props ?? {};

    return deleteSettlementStatisticsRevenuePurpose(
      convertResultId,
      settlementStatisticsRevenuePurposeId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSettlementStatisticsRevenuePurposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSettlementStatisticsRevenuePurpose>>
>;

export type DeleteSettlementStatisticsRevenuePurposeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳入区分削除
 */
export const useDeleteSettlementStatisticsRevenuePurpose = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSettlementStatisticsRevenuePurpose>>,
      TError,
      { convertResultId: string; settlementStatisticsRevenuePurposeId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSettlementStatisticsRevenuePurpose>>,
  TError,
  { convertResultId: string; settlementStatisticsRevenuePurposeId: string },
  TContext
> => {
  const mutationOptions = getDeleteSettlementStatisticsRevenuePurposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の歳出コード振り結果のレコード一覧を取得します。
各種フィルタ条件とキーワード検索に対応しています。

 * @summary 決算統計コンバーター変換結果歳出レコード一覧取得
 */
export const getConvertResultExpenditures = (
  convertResultId: string,
  params?: GetConvertResultExpendituresParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PagedExpenditureRecordsResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/expenditures`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetConvertResultExpendituresQueryKey = (
  convertResultId?: string,
  params?: GetConvertResultExpendituresParams,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/expenditures`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConvertResultExpendituresQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultExpenditures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpendituresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditures>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConvertResultExpendituresQueryKey(convertResultId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConvertResultExpenditures>>> = ({
    signal,
  }) => getConvertResultExpenditures(convertResultId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultExpenditures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultExpendituresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultExpenditures>>
>;
export type GetConvertResultExpendituresQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultExpenditures<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: undefined | GetConvertResultExpendituresParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditures>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditures>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditures>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditures<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpendituresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditures>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditures>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditures>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditures<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpendituresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditures>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳出レコード一覧取得
 */

export function useGetConvertResultExpenditures<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditures>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpendituresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultExpenditures>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultExpendituresQueryOptions(
    convertResultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の歳入コード振り結果のレコード一覧を取得します。
各種フィルタ条件とキーワード検索に対応しています。

 * @summary 決算統計コンバーター変換結果歳入レコード一覧取得
 */
export const getConvertResultRevenues = (
  convertResultId: string,
  params?: GetConvertResultRevenuesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PagedRevenueRecordsResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenues`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetConvertResultRevenuesQueryKey = (
  convertResultId?: string,
  params?: GetConvertResultRevenuesParams,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/revenues`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConvertResultRevenuesQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultRevenues>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenuesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenues>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConvertResultRevenuesQueryKey(convertResultId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConvertResultRevenues>>> = ({
    signal,
  }) => getConvertResultRevenues(convertResultId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultRevenues>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultRevenuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultRevenues>>
>;
export type GetConvertResultRevenuesQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultRevenues<
  TData = Awaited<ReturnType<typeof getConvertResultRevenues>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: undefined | GetConvertResultRevenuesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenues>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenues>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenues>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenues<
  TData = Awaited<ReturnType<typeof getConvertResultRevenues>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenuesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenues>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenues>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenues>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenues<
  TData = Awaited<ReturnType<typeof getConvertResultRevenues>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenuesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenues>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳入レコード一覧取得
 */

export function useGetConvertResultRevenues<
  TData = Awaited<ReturnType<typeof getConvertResultRevenues>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenuesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenues>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultRevenuesQueryOptions(convertResultId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定された決算統計コンバーター変換結果歳入レコードの決算統計目的、臨時経常区分、財源区分を更新します

 * @summary 決算統計コンバーター変換結果歳入レコード更新
 */
export const patchSettlementStatisticsRevenue = (
  convertResultId: string,
  revenueId: string,
  settlementStatisticsRevenuePatchRequest: BodyType<SettlementStatisticsRevenuePatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenues/${revenueId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsRevenuePatchRequest,
    },
    options,
  );
};

export const getPatchSettlementStatisticsRevenueMutationOptions = <
  TError = ErrorType<ErrorResponse | undefined>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettlementStatisticsRevenue>>,
    TError,
    {
      convertResultId: string;
      revenueId: string;
      data: BodyType<SettlementStatisticsRevenuePatchRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenue>>,
  TError,
  {
    convertResultId: string;
    revenueId: string;
    data: BodyType<SettlementStatisticsRevenuePatchRequest>;
  },
  TContext
> => {
  const mutationKey = ['patchSettlementStatisticsRevenue'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettlementStatisticsRevenue>>,
    {
      convertResultId: string;
      revenueId: string;
      data: BodyType<SettlementStatisticsRevenuePatchRequest>;
    }
  > = (props) => {
    const { convertResultId, revenueId, data } = props ?? {};

    return patchSettlementStatisticsRevenue(convertResultId, revenueId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettlementStatisticsRevenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenue>>
>;
export type PatchSettlementStatisticsRevenueMutationBody =
  BodyType<SettlementStatisticsRevenuePatchRequest>;
export type PatchSettlementStatisticsRevenueMutationError = ErrorType<ErrorResponse | undefined>;

/**
 * @summary 決算統計コンバーター変換結果歳入レコード更新
 */
export const usePatchSettlementStatisticsRevenue = <
  TError = ErrorType<ErrorResponse | undefined>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettlementStatisticsRevenue>>,
      TError,
      {
        convertResultId: string;
        revenueId: string;
        data: BodyType<SettlementStatisticsRevenuePatchRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenue>>,
  TError,
  {
    convertResultId: string;
    revenueId: string;
    data: BodyType<SettlementStatisticsRevenuePatchRequest>;
  },
  TContext
> => {
  const mutationOptions = getPatchSettlementStatisticsRevenueMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の財源充当結果のレコード一覧を歳入軸で取得します。
歳入サマリーの情報にネストする形で歳出の情報が返されます。

 * @summary 決算統計コンバーター変換結果財源充当レコード一覧取得（歳入軸）
 */
export const getConvertResultRevenueAxisRevenueAppropriations = (
  convertResultId: string,
  params?: GetConvertResultRevenueAxisRevenueAppropriationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PagedRevenueAxisRevenueAppropriationsResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenue-axis-revenue-appropriations`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetConvertResultRevenueAxisRevenueAppropriationsQueryKey = (
  convertResultId?: string,
  params?: GetConvertResultRevenueAxisRevenueAppropriationsParams,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/revenue-axis-revenue-appropriations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConvertResultRevenueAxisRevenueAppropriationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAxisRevenueAppropriationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultRevenueAxisRevenueAppropriationsQueryKey(convertResultId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>
  > = ({ signal }) =>
    getConvertResultRevenueAxisRevenueAppropriations(
      convertResultId,
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultRevenueAxisRevenueAppropriationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>
>;
export type GetConvertResultRevenueAxisRevenueAppropriationsQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultRevenueAxisRevenueAppropriations<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: undefined | GetConvertResultRevenueAxisRevenueAppropriationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenueAxisRevenueAppropriations<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAxisRevenueAppropriationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenueAxisRevenueAppropriations<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAxisRevenueAppropriationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果財源充当レコード一覧取得（歳入軸）
 */

export function useGetConvertResultRevenueAxisRevenueAppropriations<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAxisRevenueAppropriationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAxisRevenueAppropriations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultRevenueAxisRevenueAppropriationsQueryOptions(
    convertResultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の歳出分析を実行します。

 * @summary 決算統計コンバーター変換結果歳出分析
 */
export const getConvertResultExpenditureAnalysis = (
  convertResultId: string,
  params?: GetConvertResultExpenditureAnalysisParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AnalysisResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/expenditure-analysis`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetConvertResultExpenditureAnalysisQueryKey = (
  convertResultId?: string,
  params?: GetConvertResultExpenditureAnalysisParams,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/expenditure-analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConvertResultExpenditureAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpenditureAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultExpenditureAnalysisQueryKey(convertResultId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>> = ({
    signal,
  }) => getConvertResultExpenditureAnalysis(convertResultId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultExpenditureAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>
>;
export type GetConvertResultExpenditureAnalysisQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultExpenditureAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: undefined | GetConvertResultExpenditureAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditureAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpenditureAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditureAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpenditureAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳出分析
 */

export function useGetConvertResultExpenditureAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultExpenditureAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditureAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultExpenditureAnalysisQueryOptions(
    convertResultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の歳入分析を実行します。

 * @summary 決算統計コンバーター変換結果歳入分析
 */
export const getConvertResultRevenueAnalysis = (
  convertResultId: string,
  params?: GetConvertResultRevenueAnalysisParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AnalysisResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenue-analysis`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetConvertResultRevenueAnalysisQueryKey = (
  convertResultId?: string,
  params?: GetConvertResultRevenueAnalysisParams,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/revenue-analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConvertResultRevenueAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConvertResultRevenueAnalysisQueryKey(convertResultId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>> = ({
    signal,
  }) => getConvertResultRevenueAnalysis(convertResultId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultRevenueAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>
>;
export type GetConvertResultRevenueAnalysisQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultRevenueAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: undefined | GetConvertResultRevenueAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenueAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenueAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳入分析
 */

export function useGetConvertResultRevenueAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getConvertResultRevenueAnalysis>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultRevenueAnalysisQueryOptions(
    convertResultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の財源充当分析を実行します。

 * @summary 決算統計コンバーター変換結果財源充当分析
 */
export const getConvertResultRevenueAppropriationAnalysis = (
  convertResultId: string,
  params?: GetConvertResultRevenueAppropriationAnalysisParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AnalysisResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenue-appropriation-analysis`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetConvertResultRevenueAppropriationAnalysisQueryKey = (
  convertResultId?: string,
  params?: GetConvertResultRevenueAppropriationAnalysisParams,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/revenue-appropriation-analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConvertResultRevenueAppropriationAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAppropriationAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultRevenueAppropriationAnalysisQueryKey(convertResultId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>
  > = ({ signal }) =>
    getConvertResultRevenueAppropriationAnalysis(convertResultId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultRevenueAppropriationAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>
>;
export type GetConvertResultRevenueAppropriationAnalysisQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultRevenueAppropriationAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params: undefined | GetConvertResultRevenueAppropriationAnalysisParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenueAppropriationAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAppropriationAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenueAppropriationAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAppropriationAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果財源充当分析
 */

export function useGetConvertResultRevenueAppropriationAnalysis<
  TData = Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  params?: GetConvertResultRevenueAppropriationAnalysisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenueAppropriationAnalysis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultRevenueAppropriationAnalysisQueryOptions(
    convertResultId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定された決算統計コンバーター変換結果歳出レコードの決算統計目的、決算統計性質、臨時経常区分、単独補助区分を更新します

 * @summary 決算統計コンバーター変換結果歳出レコード更新
 */
export const patchSettlementStatisticsExpenditure = (
  convertResultId: string,
  expenditureId: string,
  settlementStatisticsExpenditurePatchRequest: BodyType<SettlementStatisticsExpenditurePatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/expenditures/${expenditureId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsExpenditurePatchRequest,
    },
    options,
  );
};

export const getPatchSettlementStatisticsExpenditureMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettlementStatisticsExpenditure>>,
    TError,
    {
      convertResultId: string;
      expenditureId: string;
      data: BodyType<SettlementStatisticsExpenditurePatchRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditure>>,
  TError,
  {
    convertResultId: string;
    expenditureId: string;
    data: BodyType<SettlementStatisticsExpenditurePatchRequest>;
  },
  TContext
> => {
  const mutationKey = ['patchSettlementStatisticsExpenditure'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettlementStatisticsExpenditure>>,
    {
      convertResultId: string;
      expenditureId: string;
      data: BodyType<SettlementStatisticsExpenditurePatchRequest>;
    }
  > = (props) => {
    const { convertResultId, expenditureId, data } = props ?? {};

    return patchSettlementStatisticsExpenditure(
      convertResultId,
      expenditureId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettlementStatisticsExpenditureMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditure>>
>;
export type PatchSettlementStatisticsExpenditureMutationBody =
  BodyType<SettlementStatisticsExpenditurePatchRequest>;
export type PatchSettlementStatisticsExpenditureMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果歳出レコード更新
 */
export const usePatchSettlementStatisticsExpenditure = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettlementStatisticsExpenditure>>,
      TError,
      {
        convertResultId: string;
        expenditureId: string;
        data: BodyType<SettlementStatisticsExpenditurePatchRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettlementStatisticsExpenditure>>,
  TError,
  {
    convertResultId: string;
    expenditureId: string;
    data: BodyType<SettlementStatisticsExpenditurePatchRequest>;
  },
  TContext
> => {
  const mutationOptions = getPatchSettlementStatisticsExpenditureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 決算統計コンバーター変換結果の歳出コード振りの予測精度を確認します。

 * @summary 決算統計コンバーター変換結果歳出予測精度確認
 */
export const getConvertResultExpenditurePredictionAccuracy = (
  convertResultId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ExpenditurePredictionAccuracyResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/expenditure-prediction-accuracy`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetConvertResultExpenditurePredictionAccuracyQueryKey = (
  convertResultId?: string,
) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/expenditure-prediction-accuracy`,
  ] as const;
};

export const getGetConvertResultExpenditurePredictionAccuracyQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConvertResultExpenditurePredictionAccuracyQueryKey(convertResultId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>
  > = ({ signal }) =>
    getConvertResultExpenditurePredictionAccuracy(convertResultId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultExpenditurePredictionAccuracyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>
>;
export type GetConvertResultExpenditurePredictionAccuracyQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultExpenditurePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditurePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultExpenditurePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳出予測精度確認
 */

export function useGetConvertResultExpenditurePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultExpenditurePredictionAccuracy>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultExpenditurePredictionAccuracyQueryOptions(
    convertResultId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の歳入コード振りの予測精度を確認します。

 * @summary 決算統計コンバーター変換結果歳入予測精度確認
 */
export const getConvertResultRevenuePredictionAccuracy = (
  convertResultId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<RevenuePredictionAccuracyResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenue-prediction-accuracy`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getGetConvertResultRevenuePredictionAccuracyQueryKey = (convertResultId?: string) => {
  return [
    `/settlement-statistics/convert-results/${convertResultId}/revenue-prediction-accuracy`,
  ] as const;
};

export const getGetConvertResultRevenuePredictionAccuracyQueryOptions = <
  TData = Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConvertResultRevenuePredictionAccuracyQueryKey(convertResultId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>
  > = ({ signal }) =>
    getConvertResultRevenuePredictionAccuracy(convertResultId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!convertResultId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConvertResultRevenuePredictionAccuracyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>
>;
export type GetConvertResultRevenuePredictionAccuracyQueryError = ErrorType<ErrorResponse>;

export function useGetConvertResultRevenuePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenuePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
          TError,
          Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConvertResultRevenuePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 決算統計コンバーター変換結果歳入予測精度確認
 */

export function useGetConvertResultRevenuePredictionAccuracy<
  TData = Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
  TError = ErrorType<ErrorResponse>,
>(
  convertResultId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConvertResultRevenuePredictionAccuracy>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConvertResultRevenuePredictionAccuracyQueryOptions(
    convertResultId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 決算統計コンバーター変換結果の財源充当レコードを作成します。

 * @summary 決算統計コンバーター変換結果財源充当レコード作成
 */
export const postSettlementStatisticsRevenueAppropriation = (
  convertResultId: string,
  settlementStatisticsRevenueAppropriationPostRequest: BodyType<SettlementStatisticsRevenueAppropriationPostRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SettlementStatisticsRevenueAppropriationResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenue-appropriations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsRevenueAppropriationPostRequest,
      signal,
    },
    options,
  );
};

export const getPostSettlementStatisticsRevenueAppropriationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettlementStatisticsRevenueAppropriation>>,
    TError,
    {
      convertResultId: string;
      data: BodyType<SettlementStatisticsRevenueAppropriationPostRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettlementStatisticsRevenueAppropriation>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsRevenueAppropriationPostRequest> },
  TContext
> => {
  const mutationKey = ['postSettlementStatisticsRevenueAppropriation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettlementStatisticsRevenueAppropriation>>,
    { convertResultId: string; data: BodyType<SettlementStatisticsRevenueAppropriationPostRequest> }
  > = (props) => {
    const { convertResultId, data } = props ?? {};

    return postSettlementStatisticsRevenueAppropriation(convertResultId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostSettlementStatisticsRevenueAppropriationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettlementStatisticsRevenueAppropriation>>
>;
export type PostSettlementStatisticsRevenueAppropriationMutationBody =
  BodyType<SettlementStatisticsRevenueAppropriationPostRequest>;
export type PostSettlementStatisticsRevenueAppropriationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果財源充当レコード作成
 */
export const usePostSettlementStatisticsRevenueAppropriation = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettlementStatisticsRevenueAppropriation>>,
      TError,
      {
        convertResultId: string;
        data: BodyType<SettlementStatisticsRevenueAppropriationPostRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettlementStatisticsRevenueAppropriation>>,
  TError,
  { convertResultId: string; data: BodyType<SettlementStatisticsRevenueAppropriationPostRequest> },
  TContext
> => {
  const mutationOptions = getPostSettlementStatisticsRevenueAppropriationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定された決算統計コンバーター変換結果財源充当レコードを更新します。

 * @summary 決算統計コンバーター変換結果財源充当レコード更新
 */
export const patchSettlementStatisticsRevenueAppropriation = (
  convertResultId: string,
  revenueAppropriationId: string,
  settlementStatisticsRevenueAppropriationPatchRequest: BodyType<SettlementStatisticsRevenueAppropriationPatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenue-appropriations/${revenueAppropriationId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: settlementStatisticsRevenueAppropriationPatchRequest,
    },
    options,
  );
};

export const getPatchSettlementStatisticsRevenueAppropriationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettlementStatisticsRevenueAppropriation>>,
    TError,
    {
      convertResultId: string;
      revenueAppropriationId: string;
      data: BodyType<SettlementStatisticsRevenueAppropriationPatchRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenueAppropriation>>,
  TError,
  {
    convertResultId: string;
    revenueAppropriationId: string;
    data: BodyType<SettlementStatisticsRevenueAppropriationPatchRequest>;
  },
  TContext
> => {
  const mutationKey = ['patchSettlementStatisticsRevenueAppropriation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettlementStatisticsRevenueAppropriation>>,
    {
      convertResultId: string;
      revenueAppropriationId: string;
      data: BodyType<SettlementStatisticsRevenueAppropriationPatchRequest>;
    }
  > = (props) => {
    const { convertResultId, revenueAppropriationId, data } = props ?? {};

    return patchSettlementStatisticsRevenueAppropriation(
      convertResultId,
      revenueAppropriationId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchSettlementStatisticsRevenueAppropriationMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenueAppropriation>>
>;
export type PatchSettlementStatisticsRevenueAppropriationMutationBody =
  BodyType<SettlementStatisticsRevenueAppropriationPatchRequest>;
export type PatchSettlementStatisticsRevenueAppropriationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果財源充当レコード更新
 */
export const usePatchSettlementStatisticsRevenueAppropriation = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettlementStatisticsRevenueAppropriation>>,
      TError,
      {
        convertResultId: string;
        revenueAppropriationId: string;
        data: BodyType<SettlementStatisticsRevenueAppropriationPatchRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettlementStatisticsRevenueAppropriation>>,
  TError,
  {
    convertResultId: string;
    revenueAppropriationId: string;
    data: BodyType<SettlementStatisticsRevenueAppropriationPatchRequest>;
  },
  TContext
> => {
  const mutationOptions = getPatchSettlementStatisticsRevenueAppropriationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定された決算統計コンバーター変換結果財源充当レコードを削除します。

 * @summary 決算統計コンバーター変換結果財源充当レコード削除
 */
export const deleteSettlementStatisticsRevenueAppropriation = (
  convertResultId: string,
  revenueAppropriationId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/settlement-statistics/convert-results/${convertResultId}/revenue-appropriations/${revenueAppropriationId}`,
      method: 'DELETE',
    },
    options,
  );
};

export const getDeleteSettlementStatisticsRevenueAppropriationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSettlementStatisticsRevenueAppropriation>>,
    TError,
    { convertResultId: string; revenueAppropriationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSettlementStatisticsRevenueAppropriation>>,
  TError,
  { convertResultId: string; revenueAppropriationId: string },
  TContext
> => {
  const mutationKey = ['deleteSettlementStatisticsRevenueAppropriation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSettlementStatisticsRevenueAppropriation>>,
    { convertResultId: string; revenueAppropriationId: string }
  > = (props) => {
    const { convertResultId, revenueAppropriationId } = props ?? {};

    return deleteSettlementStatisticsRevenueAppropriation(
      convertResultId,
      revenueAppropriationId,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSettlementStatisticsRevenueAppropriationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSettlementStatisticsRevenueAppropriation>>
>;

export type DeleteSettlementStatisticsRevenueAppropriationMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 決算統計コンバーター変換結果財源充当レコード削除
 */
export const useDeleteSettlementStatisticsRevenueAppropriation = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSettlementStatisticsRevenueAppropriation>>,
      TError,
      { convertResultId: string; revenueAppropriationId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSettlementStatisticsRevenueAppropriation>>,
  TError,
  { convertResultId: string; revenueAppropriationId: string },
  TContext
> => {
  const mutationOptions = getDeleteSettlementStatisticsRevenueAppropriationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
